import dayjs from 'dayjs'

/**
 * Mock Sentry Issues Data - Dispatch Web Workstream
 * Matches the actual API response structure
 */
export const mockSentryIssuesDispatch = {
  success: true,
  issues: [
    {
      id: '6843177840',
      title: 'PermissionError: User not authorized to assign drivers',
      culprit: '/dispatch/assignments/create',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'PermissionError',
        value: 'User not authorized to assign drivers',
        type: 'PermissionError',
        filename: 'AssignmentHandler.tsx',
        function: 'checkPermissions',
        in_app_frame_mix: 'in-app-only',
      },
      numComments: 1,
      userCount: 4,
      count: 22,
      firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
      lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177840/',
      shortId: 'DISPATCH-1K1',
      project: {
        id: '4507465295659005',
        name: 'dispatch-web',
        slug: 'dispatch-web',
        platform: 'javascript-react',
      },
      assignedTo: {
        type: 'user',
        name: 'David Lee',
        email: 'david.lee@daylight.com',
      },
      isBookmarked: false,
      isSubscribed: true,
      isUnhandled: true,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'high',
      filtered: {
        count: 22,
        userCount: 4,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      lifetime: {
        count: 22,
        userCount: 4,
        firstSeen: dayjs().subtract(2, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(1, 'hour').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177841',
      title: 'NetworkError: Failed to fetch fleet status',
      culprit: '/dispatch/fleet/status',
      status: 'unresolved',
      level: 'warning',
      type: 'error',
      metadata: {
        title: 'AxiosError',
        value: 'Network Error',
        type: 'AxiosError',
        filename: 'axios/lib/core/Axios.js',
        function: 'handleError',
        in_app_frame_mix: 'system-only',
      },
      numComments: 0,
      userCount: 6,
      count: 35,
      firstSeen: dayjs().subtract(1, 'month').toISOString(),
      lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177841/',
      shortId: 'DISPATCH-2L2',
      project: {
        id: '4507465295659005',
        name: 'dispatch-web',
        slug: 'dispatch-web',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: false,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'low',
      filtered: {
        count: 35,
        userCount: 6,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      },
      lifetime: {
        count: 35,
        userCount: 6,
        firstSeen: dayjs().subtract(1, 'month').toISOString(),
        lastSeen: dayjs().subtract(30, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
  ],
  pagination: {
    nextCursor: null,
    hasMore: false,
    recordCount: 2,
  },
  'x-hits': 2,
  recordCount: 2,
}

export const mockPriorityCountsDispatch = {
  success: true,
  'priority-counts': {
    high: 1,
    medium: 0,
    low: 1,
  },
  'x-hits': 2,
}
